import { useQuery } from "@tanstack/react-query";
import GlobalAppAPI from "../../api/GlobalAppAPI";
import { useAtomValue } from "jotai";
import { queriesEnabledAtom } from "../../../atoms/GlobalAtoms";

const empty: [] = [];

/**
 * Fetches ALL global apps.
 */
export default function useGlobalApps(disabled = false) {
  const queriesEnabled = useAtomValue(queriesEnabledAtom);

  const globalApps = useQuery({
    queryKey: ["globalApps"],
    queryFn: () =>
      GlobalAppAPI.getGlobalApps().then((data) => data?.data?.data?.globalApps),
    enabled: queriesEnabled && !disabled,
  });

  return {
    globalApps: globalApps.data ?? empty,
    loadingApps: globalApps.isLoading,
  };
}
